<template>
    <div class="preview tw-mb-4">
        <div class="preview-short">
            <div class="tw-h-64 tw-mb-6" v-if="servicePhoto">
                <img
                    class="tw-rounded-md tw-object-cover tw-block tw-w-full tw-h-full"
                    :src="buildPhotoURL(servicePhoto)"
                    alt="Service photo"
                />
            </div>
            <div class="tw-mb-4">
                <div class="tw-flex tw-flex-row tw-justify-between tw-items-center tw-font-semibold tw-mb-2 preview">
                    <img :src="calendarIcon" alt="calendar icon" />
                    <span>{{ date }}</span>
                </div>
                <div class="tw-flex tw-flex-row tw-justify-between tw-items-center tw-font-semibold tw-mb-4 preview">
                    <img :src="clockIcon" alt="clock icon" />
                    <span>{{ time }}</span>
                </div>
            </div>
            <table class="summary-table tw-w-full tw-my-8">
                <tbody>
                    <tr>
                        <td align="left" class="tw-text-sm tw-py-1">
                            {{ translate('customerInfoAndPayment.total_people') }}
                        </td>
                        <td align="right" class="tw-text-sm tw-py-1">
                            {{ totalPeople }}
                        </td>
                    </tr>
                    <tr>
                        <td align="left" class="tw-text-sm tw-py-1">
                            {{ translate('customerInfoAndPayment.price') }}
                        </td>
                        <td align="right" class="tw-text-sm tw-py-1">{{ priceFormatted }}</td>
                    </tr>
                    <tr v-if="appliedCoupon">
                        <td align="left" class="tw-text-sm tw-py-1">
                            {{ translate('customerInfoAndPayment.coupon_discount') }}
                        </td>
                        <td align="right" class="tw-text-sm tw-py-1">
                            [{{ appliedCoupon.name }}&nbsp;-&nbsp; {{ appliedCoupon.discount_percentage }}&percnt;] -{{
                                couponDiscountFormatted
                            }}
                        </td>
                    </tr>
                    <tr>
                        <td align="left" class="tw-text-sm tw-py-1">
                            {{ translate('customerInfoAndPayment.subtotal') }}
                        </td>
                        <td align="right" class="tw-text-sm tw-py-1">
                            {{ subTotalFormatted }}
                        </td>
                    </tr>
                    <tr>
                        <td align="left" class="tw-text-sm tw-py-1 tw-font-bold tw-uppercase">
                            {{ translate('customerInfoAndPayment.total') }}
                        </td>
                        <td align="right" class="tw-text-sm tw-py-1 tw-font-bold tw-uppercase total">
                            {{ totalFormatted }}
                        </td>
                    </tr>
                </tbody>
            </table>
            <table class="summary-table tw-my-4">
                <tbody>
                    <tr v-for="item in items" :key="item.id">
                        <td align="left" class="tw-text-base">{{ item.name }}</td>
                        <td align="center" class="tw-text-base">{{ item.people }}</td>
                        <td align="right" class="tw-text-base">{{ item.price.amount }} {{ item.price.currency }}</td>
                    </tr>
                </tbody>
            </table>
            <div class="calendar-summary-item tw-my-4 tw-text-center">
                <!-- edit offers -->
                <a class="tw-text-base tw-underline tw-font-semibold" href="#" @click.prevent="$emit('changeView')">
                    {{ translate('customerInfoAndPayment.edit') }}
                </a>
            </div>
        </div>
    </div>
</template>
<script>
import i18n from '@js/vue/mixins/i18n';
import imgClient from '../../../utils/imgxClient';
import calendarIcon from '@images/calendar.svg';
import clockIcon from '@images/clock-circular-outline.svg';
import { LocalDate, DateTimeFormatter } from '@js-joda/core';
import { mapGetters } from 'vuex';

export default {
    name: 'Booking',
    mixins: [i18n],
    inject: ['lang', 'translations'],
    data() {
        return {
            calendarIcon,
            clockIcon,
            dateDisplayedFormat: 'dd.MM.yyyy',
        };
    },
    methods: {
        buildPhotoURL(photo) {
            // same width as in the photo gallery (with min 4 images) TODO caching
            return imgClient.buildURL(photo.photo_name, {
                w: 656,
                auto: 'compress,format,enhance',
            });
        },
        formatDate(date) {
            const pattern = DateTimeFormatter.ofPattern(this.dateDisplayedFormat);
            return LocalDate.parse(date).format(pattern);
        },
    },
    computed: {
        ...mapGetters('booking', [
            'getDate',
            'getTime',
            'getTotalPeople',
            'getAppliedCoupon',
            'getServicePhoto',
            'getPriceFormatted',
            'getSubTotalFormatted',
            'getTotalFormatted',
            'getItems',
        ]),
        date() {
            return this.getDate;
        },
        time() {
            return this.getTime;
        },
        totalPeople() {
            return this.getTotalPeople;
        },
        appliedCoupon() {
            return this.getAppliedCoupon;
        },
        servicePhoto() {
            return this.getServicePhoto;
        },
        priceFormatted() {
            return this.getPriceFormatted;
        },
        subTotalFormatted() {
            return this.getSubTotalFormatted;
        },
        totalFormatted() {
            return this.getTotalFormatted;
        },
        items() {
            return this.getItems;
        },
    },
};
</script>
